var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWritingTools(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.205 11.027c-.175.468-.322.9-.455 1.337.72-.523 1.576-.854 2.564-.978 1.885-.235 3.56-1.48 4.407-3.043l-1.092-1.091 1.06-1.062.75-.75c.322-.323.686-.919 1.07-1.777-4.194.65-6.763 3.22-8.305 7.364h.001Zm7.545-3.776L13.5 8c-.75 2.25-3 4.5-6 4.875-2.002.25-3.252 1.625-3.752 4.125H2.25C3 12.5 4.5 2 15.75 2c-.75 2.248-1.498 3.747-2.248 4.498l-.752.753Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingTools);
export default __webpack_public_path__ + "static/media/writing-tools.cd86d44b.svg";
export { ForwardRef as ReactComponent };